// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCPsDRWQDTTFunMrFIkOkvU5je2qFQqGvc",
  authDomain: "passed-apps.firebaseapp.com",
  projectId: "passed-apps",
  storageBucket: "passed-apps.appspot.com",
  messagingSenderId: "70543051126",
  appId: "1:70543051126:web:be862cdae132e988f0d257",
  measurementId: "G-FB1P9B8EXW",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);
